import * as React from 'react'
import { IVisualizationState, IPeerGroupTabsProps } from '../../lib/http'
import PanelGraph from 'app/components/tabs/PanelGraph'

export class VisualizationFive extends React.Component<IPeerGroupTabsProps, IVisualizationState> {
  state: IVisualizationState = {
    title: '',
    data: [],
    categories: [],
    loading: false,
    series: [],
    filters: { assetLevel: 0 },
  }

  componentDidMount() {
    this.loadSeries()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel || prevProps.data.length !== this.props.data.length) {
      this.setState({ filters: this.props.filters, data: this.props.data }, () => {
        this.loadSeries()
      })
    }
  }

  loadSeries() {
    const { data } = this.state

    const currentDataset = data.find((dataPoint) => dataPoint.filterId === this.props.filters.assetLevel)
    const categories = []
    const dataForSeries = []

    if (currentDataset) {
      categories.push(currentDataset['Giv_T_V5_DisbCol1'])
      categories.push(currentDataset['Giv_T_V5_DisbCol2'])
      categories.push(currentDataset['Giv_T_V5_DisbCol3'])
      categories.push(currentDataset['Giv_T_V5_DisbCol4'])
      categories.push(currentDataset['Giv_T_V5_DisbCol5'])
      categories.push(currentDataset['Giv_T_V5_DisbCol6'])
      categories.push(currentDataset['Giv_T_V5_DisbCol7'])
      categories.push(currentDataset['Giv_T_V5_DisbCol8'])
      categories.push(currentDataset['Giv_T_V5_DisbCol9'])
      categories.push(currentDataset['Giv_T_V5_DisbCol10'])
      categories.push(currentDataset['Giv_T_V5_DisbCol11'])
      categories.push(currentDataset['Giv_T_V5_DisbCol12'])
      categories.push(currentDataset['Giv_T_V5_DisbCol13'])
      categories.push(currentDataset['Giv_T_V5_DisbCol14'])
      categories.push(currentDataset['Giv_T_V5_DisbCol15'])

      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol1'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol2'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol3'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol4'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol5'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol6'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol7'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol8'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol9'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol10'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol11'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol12'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol13'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol14'])
      dataForSeries.push(currentDataset['Giv_N_V5_DisbCol15'])
    }

    const roundedData = dataForSeries.map(value => Math.round(parseFloat(value) * 100.0))

    const title = currentDataset ? currentDataset['Giv_T_V5_vVis5Title'] : ''
    const series = [{ color: '#C8DDF0', name: 'Percentage of Assets', data: roundedData, borderWidth: 1, borderColor: '#a1a1a1' }]

    this.setState({ categories, series, title, })

  }

  static getPublicIndexConfig(series, categories, title) {
    return {
      chart: { type: 'column' },
      title: {
        text: title
      },
      xAxis: {
        categories
      },
      yAxis: {
        visible: false,
        opposite: false,
        title: '',
        labels: {
          format: '{value}%',
        },
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            format: '{y}%',
          }
        }
      },
      tooltip: {
        valueSuffix: '%'
      },
      legend: { enabled: false },
      credits: { enabled: false },
      series
    }
  }

  render() {
    const { loading, categories, title, series } = this.state
    return (
      <PanelGraph title="" loading={loading} chartConfig={VisualizationFive.getPublicIndexConfig(series, categories, title)} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/GIV/VisualizationFive/index.tsx